import { init, error, warn, log } from '@appfolio/browser-reporter';
import { DatadogAdapter } from '@appfolio/browser-reporter/adapters/datadog';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const SCRUB_QUERY_PARAMS = ['magic_link_token'];

const scrubUrl = (url) => {
  if (!url) return url;
  return SCRUB_QUERY_PARAMS.reduce(
    (acc, param) => acc.replace(new RegExp(`([?&])${param}=[^&#]*`, 'gi'), `$1${param}=[REDACTED]`),
    url,
  );
};

const adapters = [];

if (process.env.DD_CLIENT_TOKEN) {
  datadogLogs.init({
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'passport-frontend',
    env: process.env.DEPLOYMENT_ENV,
    forwardErrorsToLogs: false,
    beforeSend: (log) => {
      if (log.view) {
        log.view.url = scrubUrl(log.view.url);
        log.view.referrer = scrubUrl(log.view.referrer);
      }
      return true;
    },
  });
  adapters.push(new DatadogAdapter());

  if (process.env.DD_RUM_APPLICATION_ID) {
    datadogRum.init({
      applicationId: process.env.DD_RUM_APPLICATION_ID,
      clientToken: process.env.DD_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'passport-frontend',
      env: process.env.DEPLOYMENT_ENV,
      sessionSampleRate: 5,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      // Datadog RUM reports the navigation entry URL (initial_document resource), which still has the token.
      // Any new event field that can hold a URL must go through scrubUrl. See AGENTS.md "Magic link tokens".
      beforeSend: (event) => {
        if (event.view) {
          event.view.url = scrubUrl(event.view.url);
          event.view.referrer = scrubUrl(event.view.referrer);
        }
        if (event.resource) {
          event.resource.url = scrubUrl(event.resource.url);
        }
        return true;
      },
    });
  }
}

init(adapters);

export default { error, warn, log };
